import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Mail, Bell } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { DashboardLayout } from "@/components/DashboardLayout";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function Settings() {
  const { user } = useAuth();
  const [emailOn, setEmailOn] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) setEmailOn(user.email_notifications !== false);
  }, [user]);

  const toggle = async (val) => {
    setEmailOn(val);
    setSaving(true);
    try {
      await api.patch("/me/preferences", { email_notifications: val });
      toast.success(val ? "Email attivate." : "Email disattivate.");
    } catch (e) {
      setEmailOn(!val);
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <DashboardLayout title="Impostazioni">
      <div className="max-w-2xl">
        <h2 className="font-display text-lg font-semibold text-slate-900 mb-1">Notifiche</h2>
        <p className="text-sm text-slate-500 mb-6">Gestisci come vuoi ricevere gli aggiornamenti sulle tue segnalazioni.</p>

        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
          className="rounded-2xl border border-slate-200 bg-white p-6 flex items-start justify-between gap-6" data-testid="pref-email-card">
          <div className="flex items-start gap-4">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#0A1128] text-[#D4AF37]">
              <Mail className="h-5 w-5" />
            </span>
            <div>
              <p className="font-display font-medium text-slate-900">Notifiche email</p>
              <p className="text-sm text-slate-500 mt-0.5 max-w-md">
                Ricevi un'email ad ogni evento chiave della pratica (contatto, incarico, proposta, merito fidelizzazione…).
              </p>
            </div>
          </div>
          <Switch checked={emailOn} disabled={saving} onCheckedChange={toggle} data-testid="pref-email-switch" className="mt-1" />
        </motion.div>

        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5 flex items-start gap-3 mt-4">
          <Bell className="h-5 w-5 text-slate-400 shrink-0" />
          <p className="text-xs text-slate-500 leading-relaxed">
            Le notifiche <strong>in-app</strong> (campanella) restano sempre attive nella tua dashboard,
            anche se disattivi le email.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
}
